"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconShapeMap = exports.variantMap = exports.buttonSizeMap = exports.sizeMap = exports.Variants = exports.Shape = exports.Size = void 0;
var colors_1 = require("../../style/colors");
exports.Size = {
    XSMALL: 'xsmall',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
exports.Shape = {
    SQUARE: 'square',
    ROUND: 'round',
};
// export const THEMES = {
//   OUTLINED: 'outlined',
//   TWO_TONE: 'two-tone',
//   ROUND: 'round',
//   SHARP: 'sharp',
// };
exports.Variants = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    FLUSH: 'flush',
};
exports.sizeMap = (_a = {},
    _a[exports.Size.XSMALL] = {
        fontSize: '10px',
    },
    _a[exports.Size.SMALL] = {
        fontSize: '14px',
    },
    _a[exports.Size.MEDIUM] = {
        fontSize: '20px',
    },
    _a[exports.Size.LARGE] = {
        fontSize: '24px',
    },
    _a);
exports.buttonSizeMap = (_b = {},
    _b[exports.Size.XSMALL] = {
        height: '18px',
        width: '18px',
    },
    _b[exports.Size.SMALL] = {
        height: '26px',
        width: '26px',
    },
    _b[exports.Size.MEDIUM] = {
        height: '34px',
        width: '34px',
    },
    _b[exports.Size.LARGE] = {
        height: '40px',
        width: '40px',
    },
    _b);
exports.variantMap = (_c = {},
    _c[exports.Variants.SECONDARY] = {
        border: "1px solid " + colors_1.SixsenseColor.Gray.LIGHT_5,
        backgroundColor: "" + colors_1.SixsenseColor.Gray.LIGHT_5,
    },
    _c[exports.Variants.PRIMARY] = {
        border: "1px solid " + colors_1.SixsenseColor.Blue.LIGHT_5,
        backgroundColor: "" + colors_1.SixsenseColor.Blue.LIGHT_5,
    },
    _c[exports.Variants.FLUSH] = {
        border: '1px solid transparent',
        backgroundColor: 'transparent',
    },
    _c);
exports.iconShapeMap = (_d = {},
    _d[exports.Shape.ROUND] = {
        borderRadius: '50%',
    },
    _d[exports.Shape.SQUARE] = {
        borderRadius: '4px',
    },
    _d);
